@if (contentlet()) {
<div class="default-faq-class">
  <h1 class="text-center faq-main-heading mt-5 mb-4">{{ contentlet()?.widgetTitle }}</h1>
  <div class="mb-2 position-relative">
    @for (faq of contentlet().faq;let idx = $index; track faq) {
    <custom-dot-cms-uve-faq [contentlet]="faq" />
    }
  </div>
</div>
}
